import { AxiosResponse } from "axios";
import BatchUpdatesService, { DslibTicketQuery } from "./batchUpdate.service";
import { queryOptions } from "@tanstack/react-query";


export const createBatchUpdatesOptionsQuery = () => queryOptions<any>({
  queryKey: ['batch-updates'],
  queryFn: async () => {
    const batchUpdatesService = BatchUpdatesService()
    return new Promise(async (resolve) => {
      await batchUpdatesService
        .getBatchUpdate({
          onSuccess: (res: AxiosResponse) => {
            resolve(res.data);
          },
        })
        .then((res) => {
          resolve(res?.data);
        });
    });
  },
  staleTime: 1000 * 60 * 5, // 5 minutes
  refetchInterval: 1000 * 60 * 5, // 5 minutes
  refetchOnWindowFocus: false,
});

export const createBatchUpdatesByIdOptionsQuery = (batchUpdateId: number) => queryOptions<any>({
  queryKey: ['batch-update-id', batchUpdateId],
  queryFn: async () => {
    const batchUpdatesService = BatchUpdatesService()
    if (batchUpdateId === 0) return new Promise(async (resolve) => {
      resolve(null)
    })
    return new Promise(async (resolve) => {
      await batchUpdatesService
        .getBatchUpdateById({ id: batchUpdateId })

        .then((res) => {
          resolve(res?.data);
        });
    });
  },
  enabled: batchUpdateId !== 0,
  staleTime: 1000 * 60 * 5, // 5 minutes
  refetchInterval: 1000 * 60 * 5, // 5 minutes
  refetchOnWindowFocus: false,
});

export const createBatchUpdatesAffectCountOptionsQuery = (query: DslibTicketQuery) => queryOptions<any>({
  queryKey: ['batch-update-affect-count', query],
  queryFn: async () => {
    await new Promise(resolve => setTimeout(resolve, 2000));
    const batchUpdatesService = BatchUpdatesService()
    if (!query) return new Promise(async (resolve) => {
      resolve(null)
    })
    return new Promise(async (resolve) => {
      await batchUpdatesService
        .getBatchUpdateAffectCount(query)
        .then((res) => {
          resolve(res?.data);
        });
    });
  },
  enabled: !!query,
  staleTime: 0,
  gcTime: 0,
  refetchInterval: 0,
  retry: false,
  refetchOnWindowFocus: false,
});

// export const createBatchUpdatesAffectCountOptionsQuery = (query: DslibTicketQuery) => queryOptions<any>({
//   queryKey: ['batch-update-affect-count', query],
//   queryFn: async () => {
//     const batchUpdatesService = BatchUpdatesService()
//     if (!query) return new Promise(async (resolve) => {
//       resolve(null)
//     })
//     return new Promise(async (resolve) => {
//       await batchUpdatesService
//         .getBatchUpdateAffectCount(query)
//         .then((res) => {
//           resolve(res?.data);
//         });
//     });
//   },
//   enabled: !!query,
//   staleTime: 1000 * 60 * 5, // 5 minutes
//   refetchInterval: 1000 * 60 * 5, // 5 minutes
//   refetchOnWindowFocus: false,
// });
